const zh = {
  nav_gallery: "修复案例",
  nav_pricing: "价目表",
  nav_b2b: "企业合作",
  nav_contact: "联系我们",
  nav_hours: "营业时间：10:00〜18:00",
  nav_cta: "免费估价",
  nav_scroll_top: "返回顶部",

  hero_h1: "重现奢品原质",
  hero_h2: "守护珍藏价值",
  hero_badge: "最短2天完工 / 照片10分钟估价",
  hero_delivery: "全国邮寄服务",
  hero_speed: "照片估价，10分钟内回复",
  hero_btn_gallery: "查看修复案例",
  hero_btn_pricing: "查看价格",

  why_title: "为什么选择我们",
  why_subtitle: "两大核心优势，成为您最信赖的奢品修复伙伴",
  why_speed_label: "速度",
  why_speed_title: "行业最快\n最短2天交货",
  why_speed_desc: "同行通常需要一周以上才能完成修复，而我们最短2天即可交货。紧急订单也可灵活安排，绝不让您久等。",
  why_speed_other_label: "其他店铺",
  why_speed_other_val: "一周以上",
  why_speed_us_label: "本店交货期",
  why_speed_us_val: "最短2天起",
  why_quality_label: "品质保证",
  why_quality_title: "修复后30天\n品质保证",
  why_quality_desc: "修复后30天内，如因正常使用出现问题，将免费重新修复。请安心将珍品交予我们。",
  why_quality_target_label: "保修范围",
  why_quality_target_val: "正常使用损耗",
  why_quality_period_label: "保修期限",
  why_quality_period_val: "修复后30天内",

  gallery_label: "修复案例",
  gallery_cta: "申请免费估价",
  gallery_repair_0: "皮革划伤修复·填补",
  gallery_repair_1: "精细图案复绘",
  gallery_repair_2: "五金镀层翻新",
  gallery_repair_3: "包面黑染还原",
  gallery_repair_4: "五金烤漆修复",
  gallery_repair_5: "深度污渍清洁",

  pricing_label: "Pricing",
  pricing_title: "修复菜单",
  pricing_subtitle: "两种方案，按需定制",
  pricing_badge_flat: "无需估价·统一定价",
  pricing_badge_no_extra: "复杂修复不额外收费",
  pricing_pack_title: "套餐服务",
  pricing_pack_popular: "人气第一",
  pricing_pack_size_s: "包包尺寸 〜20cm",
  pricing_pack_size_m: "包包尺寸 20〜30cm",
  pricing_pack_size_l: "包包尺寸 30〜40cm",
  pricing_include_0: "深度清洁",
  pricing_include_1: "四角修复（全部）",
  pricing_include_2: "边油全周重涂",
  pricing_include_3: "提手修复",
  pricing_include_4: "品牌标识修复",
  pricing_include_5: "五金抛光",
  pricing_include_6: "表面镀膜",
  pricing_pack_cta: "选择此方案",
  pricing_single_title: "单项菜单",
  pricing_single_subtitle: "按部位单独定制",
  pricing_si_0: "深度清洁",
  pricing_si_1: "皮革修复还原",
  pricing_si_2: "边油处理",
  pricing_si_3: "黑染·各色染色",
  pricing_si_4: "内衬修复",
  pricing_si_5: "五金配件修理",
  pricing_si_6: "PVC材质复原",
  pricing_si_7: "精细图案复绘",
  pricing_si_8: "珐琅修复",
  pricing_si_9: "五金镀层加工",
  pricing_note_1: "所有价格均含税。实际价格可能因材质及损伤程度有所浮动。发送照片即可在10分钟内获得精准报价。",
  pricing_note_2: "以上之外的修复项目也欢迎咨询，专业技师将为您耐心解答。",
  pricing_xl_title: "超大尺寸·特殊形状·行李箱均可接受",
  pricing_xl_desc: "超出S〜L尺码范围的大型皮具、特殊形状单品及行李箱等，将另行单独估价。欢迎随时咨询。",
  pricing_xl_cta: "咨询·获取报价",

  process_label: "How It Works",
  process_title: "简单邮寄修复流程",
  process_subtitle: "足不出户，全国均可享受服务",
  process_step_1_title: "联系我们",
  process_step_1_desc: "通过企业微信（WeCom）、LINE或邮件联系我们，发送照片即可。",
  process_step_2_title: "获取报价",
  process_step_2_desc: "收到照片后，最短10分钟内回复报价。确认金额后再下单，完全无压力。",
  process_step_2_badge: "10分钟",
  process_step_3_title: "寄送物品",
  process_step_3_desc: "确认报价后请将物品邮寄至工坊，请妥善包装。",
  process_step_4_title: "修复作业",
  process_step_4_desc: "资深工匠精心修复，最短2天即可完成。",
  process_step_4_badge: "2天",
  process_step_5_title: "寄回归还",
  process_step_5_desc: "修复完成后，精心包装后寄回，敬请查验成果。",

  b2b_badge: "企业合作",
  b2b_title: "二手奢品商家专属",
  b2b_highlight: "\u3000合作伙伴计划",
  b2b_desc: "专为从事高端二手奢品收购与销售的商家设计的B2B合作计划，同时提升修复品质与业务效率，有力支持您的商业竞争力。",
  b2b_stat_0_val: "50%",
  b2b_stat_0_label: "交期缩短率",
  b2b_stat_0_sub: "较普通订单",
  b2b_stat_1_val: "2天起",
  b2b_stat_1_label: "最短交期",
  b2b_stat_1_sub: "企业专属通道",
  b2b_stat_2_val: "30天",
  b2b_stat_2_label: "品质保证期",
  b2b_stat_2_sub: "免费保修",
  b2b_stat_3_val: "全国",
  b2b_stat_3_label: "服务范围",
  b2b_stat_3_sub: "接受邮寄",
  b2b_benefit_0_title: "账期付款",
  b2b_benefit_0_desc: "每月使用10件以上可享账期，次月底统一结算，轻松管理资金流。",
  b2b_benefit_1_title: "优先处理通道",
  b2b_benefit_1_desc: "企业合作伙伴的修复品享受专属优先处理，较普通订单缩短约50%交期。",
  b2b_benefit_2_title: "专属客服跟进",
  b2b_benefit_2_desc: "配备专属客服，一站式跟进进度、提供品质反馈，省心省力。",
  b2b_benefit_3_title: "品控报告",
  b2b_benefit_3_desc: "每件修复品均随附详细品控报告，可直接用于向客户说明的参考资料。",
  b2b_target_label: "适合以下商家",
  b2b_target_0: "二手店·当铺",
  b2b_target_1: "高端二手奢品收购销售商",
  b2b_target_2: "二手平台大量出售者",
  b2b_target_3: "百货公司·精品店",
  b2b_target_4: "酒店·旅馆寄存服务",
  b2b_cta_note: "欢迎随时咨询，专属客服将为您详细介绍。",
  b2b_cta_btn: "申请合作",

  contact_label: "Contact",
  contact_title: "联系我们",
  contact_subtitle_1: "照片估价，10分钟内回复",
  contact_subtitle_2: "发送照片即可估价",
  contact_ch_0_name: "LINE 咨询",
  contact_ch_0_target: "日本客户适用",
  contact_ch_0_desc: "添加好友后，请发送包品照片，我们将在10分钟内回复估价。",
  contact_ch_1_name: "企业微信咨询",
  contact_ch_1_target: "中文用户适用",
  contact_ch_1_desc: "支持通过企业微信（WeCom）咨询，欢迎用中文随时联系我们。",
  contact_ch_2_name: "邮件咨询",
  contact_ch_2_target: "企业客户适用",
  contact_ch_2_desc: "企业客户及二手商家请使用邮件联系，我们将尽快回复。",
  contact_logistics_1: "全国邮寄服务（运费由客户承担）",
  contact_logistics_2: "营业时间：工作日 10:00〜18:00",
  contact_mail_title: "邮件咨询",
  contact_mail_desc: "点击下方按钮发送邮件，请附上物品照片、品牌及修复部位说明，以便我们更快速为您提供方案。",
  contact_mail_tmpl_label: "邮件参考模板",
  contact_mail_tmpl_0: "姓名",
  contact_mail_tmpl_1: "所需服务（套餐 S / M / L，或单项）",
  contact_mail_tmpl_2: "包品品牌及尺寸",
  contact_mail_tmpl_3: "修复部位及需求",
  contact_mail_tmpl_4: "物品照片（附件）",
  contact_mail_cta_btn: "打开邮件应用",
  contact_line_add_btn: "LINE加好友",
  contact_wecom_add_btn: "企业微信直接联系",
  contact_mail_after: "收到照片后，最短10分钟内回复报价。",
  contact_mail_subject: "修复估价咨询",
  contact_mail_body: "姓名：\n所需服务：\n包品品牌及尺寸：\n修复部位及需求：\n\n※请同时附上物品照片。",

  company_title: "公司概况",
  ci_company: "公司名称",
  ci_rep: "代表人",
  ci_license: "古物经营许可证",
  ci_address: "地址",
  ci_hours: "营业时间",
  ci_area: "服务范围",
  ci_brands: "主要品牌",
  ci_email_label: "电子邮件",
  ci_hours_val: "10:00〜18:00（周六日及节假日休息）",
  ci_area_val: "全国（邮寄服务）",

  footer_band_delivery: "全国邮寄服务",
  footer_band_speed: "照片估价10分钟内回复",
  footer_band_hours: "工作日 10:00〜18:00",
  footer_desc: "重现奢品原质，守护珍藏价值。大阪自营工坊，专业承接高端包袋修复与复原。",
  footer_services_title: "服务",
  footer_link_0: "套餐服务",
  footer_link_1: "单项菜单",
  footer_link_2: "修复案例",
  footer_link_3: "企业合作",
  footer_link_4: "联系我们",
  footer_contact_title: "联系我们",
  footer_sns_title: "关注我们",
  footer_copyright: "© 2025 蔵新 OSAKA ATELIER. 版权所有",
  footer_privacy: "隐私政策",
  footer_law: "特定商取引法に基づく表記",
};

export default zh;